module.exports = "/_next/static/resources/man-1-d3eb027262ded1ddcab79096a6e628bc.jpg";